module.exports = __webpack_public_path__ + "static/img/8.e3d418f1.png";